import { AsyncThunk, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { filterUrls } from 'services/api.enums'
import { filterTableDataAPI } from 'services/CRUDServices'

export const filterSharePercent: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  'sharePercent',
  async (body: any) => {
    const data = await filterTableDataAPI(
      "/core-api/sharePercentage/v2/search",
      body.pageNumber,
      { ...body, pageNumber: undefined, pageSize: undefined },
      true,
      10,
      false
    )

    return data.data
  }
)

const initialState: any = {
  sharePercent: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
}

const SharePercentSlice = createSlice({
  initialState: initialState,
  name: 'sharePercent',
  reducers: {
    clearSharePercent: (state) => {
      state.sharePercent = []
    },
    setFilterSharePercent: (state, action) => {
      state.filter = action.payload
    },
  },
  extraReducers: {
    [filterSharePercent.fulfilled as any]: (state, action) => {
      state.sharePercent = action.payload
      state.fetchpost = false
    },
    [filterSharePercent.pending as any]: (state) => {
      state.fetchpost = true
    },
    [filterSharePercent.rejected as any]: (state) => {
      state.fetchpost = false
      state.errorMessage = 'wrong'
    },
  },
})

export const { setFilterSharePercent, clearSharePercent } =
  SharePercentSlice.actions
export default SharePercentSlice.reducer
